import React, { useState } from 'react';
import { CheckCircle2, ShieldCheck, ArrowRight, Phone } from 'lucide-react';
export function Hero() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <section className="relative bg-cream-100 border-b border-neutral-200 overflow-hidden" data-id="element-72">
      <div className="absolute inset-0 bg-glass-grid pointer-events-none opacity-60" data-id="element-73"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-white/60 to-cream-100/90 pointer-events-none" data-id="element-74"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-12 lg:pt-10 lg:pb-14" data-id="element-75">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-start" data-id="element-76">
          {/* Left Column: Copy */}
          <div className="lg:col-span-7 flex flex-col justify-center" data-id="element-77">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-50 text-primary-700 font-medium text-xs mb-3 w-fit border border-primary-100" data-id="element-78">
              <span className="relative flex h-2 w-2" data-id="element-79">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-500 opacity-75" data-id="element-80"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-600" data-id="element-81"></span>
              </span>
              Commercial Glass Estimates Available
            </div>

            {/* Social proof bar */}
            <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 bg-white border border-neutral-200 rounded-full shadow-sm px-4 py-2 mb-4 w-fit" aria-label="5-star reputation: Trusted by Michigan businesses, builders and property managers since 2000" data-id="element-82">
              <span className="flex items-center gap-1 text-amber-500" aria-hidden="true" data-id="element-83">
                <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 20 20" data-id="element-84">
                  <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-85" />
                </svg>
                <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 20 20" data-id="element-86">
                  <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-87" />
                </svg>
                <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 20 20" data-id="element-88">
                  <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-89" />
                </svg>
                <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 20 20" data-id="element-90">
                  <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-91" />
                </svg>
                <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 20 20" data-id="element-92">
                  <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-93" />
                </svg>
              </span>
              <span className="text-xs sm:text-sm font-semibold text-neutral-800 font-sans" data-id="element-94">
                Trusted by Michigan Businesses, Builders & Property Managers
              </span>
              <span className="hidden sm:inline text-neutral-300" data-id="element-95">·</span>
              <span className="text-xs sm:text-sm text-neutral-600 font-sans" data-id="element-96">
                Commercial Glass Since 2000
              </span>
            </div>

            <h1 className="kosins-heading text-3xl sm:text-4xl lg:text-5xl text-neutral-900 leading-[1.05] mb-4" data-id="element-97">
              <span className="text-primary-600" data-id="element-98">Commercial Glass Company</span>{' '}
              for Storefronts, Offices &{' '}
              <span className="text-primary-600" data-id="element-99">
                Contract Glazing in Michigan
              </span>
            </h1>

            <p className="text-base text-neutral-600 mb-5 max-w-2xl leading-relaxed font-sans" data-id="element-100">
              Storefront glass replacement, commercial door glass, office glass
              walls, business window replacement and full contract glazing for
              Michigan businesses, builders, contractors and property managers.
            </p>

            <ul className="space-y-2 mb-5 font-sans" data-id="element-101">
              {['Storefront glass repair, replacement, doors and commercial windows', 'Office glass walls, dividers, partitions and interior glass systems', 'Contract glazing for new construction, renovations and existing buildings', 'Accurate quotes, reliable installations and Michigan-based service'].map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-102">
                  <CheckCircle2 className="w-5 h-5 text-primary-600 shrink-0 mt-0.5" data-id="element-103" />
                  <span className="text-neutral-700 text-sm" data-id="element-104">{bullet}</span>
                </li>)}
            </ul>

            <div className="flex items-center gap-2 text-xs text-neutral-500 bg-white/70 w-fit px-3 py-1.5 rounded-md border border-neutral-200" data-id="element-105">
              <ShieldCheck className="w-4 h-4 text-neutral-400" data-id="element-106" />
              <span data-id="element-107">
                Your information is secure. Kosin's Glass will never share your
                details.
              </span>
            </div>
          </div>

          {/* Right Column: Form Card */}
          <div className="lg:col-span-5 relative z-10 w-full max-w-md mx-auto lg:max-w-none" data-id="element-108">
            <div className="bg-white rounded-md shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-neutral-200 p-5 sm:p-6" data-id="element-109">
              <div className="inline-block bg-primary-600 text-white font-semibold text-[11px] tracking-widest uppercase px-3 py-1 rounded-sm mb-3" data-id="element-110">
                Free Commercial Estimate
              </div>

              <h2 className="kosins-heading text-2xl text-neutral-900 mb-1.5 leading-tight" data-id="element-111">
                Request a Commercial Glass Quote
              </h2>
              <p className="text-xs text-neutral-500 mb-4 leading-relaxed font-sans" data-id="element-112">
                Submit your details and a Kosin's Glass team member will contact
                you to confirm company, project address, photos, dimensions,
                timeline and bid requirements.
              </p>

              {isSubmitted ? <div className="bg-primary-50 border border-primary-200 rounded-md p-5 text-center" data-id="element-113">
                  <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-114">
                    <CheckCircle2 className="w-5 h-5 text-primary-600" data-id="element-115" />
                  </div>
                  <h3 className="kosins-heading text-lg text-neutral-900 mb-1" data-id="element-116">
                    Request Received
                  </h3>
                  <p className="text-neutral-700 text-xs font-sans" data-id="element-117">
                    Thank you. A commercial glass specialist will contact you
                    shortly.
                  </p>
                </div> : <form onSubmit={handleSubmit} className="space-y-3 font-sans" data-id="element-118">
                  <div data-id="element-119">
                    <label htmlFor="fullName" className="block text-xs font-medium text-neutral-700 mb-1" data-id="element-120">
                      Full Name
                    </label>
                    <input type="text" id="fullName" required placeholder="John Smith" className="w-full px-3 py-2.5 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors outline-none text-neutral-900 placeholder:text-neutral-400 text-sm" data-id="element-121" />
                  </div>

                  <div data-id="element-122">
                    <label htmlFor="phone" className="block text-xs font-medium text-neutral-700 mb-1" data-id="element-123">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" required placeholder="(555) 123-4567" className="w-full px-3 py-2.5 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors outline-none text-neutral-900 placeholder:text-neutral-400 text-sm" data-id="element-124" />
                  </div>

                  <div data-id="element-125">
                    <label htmlFor="email" className="block text-xs font-medium text-neutral-700 mb-1" data-id="element-126">
                      Email Address
                    </label>
                    <input type="email" id="email" required placeholder="john@company.com" className="w-full px-3 py-2.5 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors outline-none text-neutral-900 placeholder:text-neutral-400 text-sm" data-id="element-127" />
                  </div>

                  <button type="submit" className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-md transition-colors flex items-center justify-center gap-2 mt-1 group uppercase tracking-wider text-xs" data-id="element-128">
                    Request My Commercial Estimate
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-129" />
                  </button>
                </form>}

              <div className="mt-4 pt-4 border-t border-neutral-100 text-center font-sans" data-id="element-130">
                <p className="text-xs text-neutral-600 flex items-center justify-center gap-1.5 mb-1" data-id="element-131">
                  Prefer to call?{' '}
                  <Phone className="w-3.5 h-3.5 text-primary-600" data-id="element-132" />{' '}
                  <a href="tel:5175457772" className="font-bold text-neutral-900 hover:text-primary-600 transition-colors" data-id="element-133">
                    517-545-7772
                  </a>
                </p>
                <p className="text-[10px] text-neutral-400" data-id="element-134">
                  We respect your privacy. Your details are safe with us.
                </p>
              </div>

              {/* Micro-testimonial */}
              <div className="mt-4 pt-4 border-t border-neutral-100 font-sans" aria-label="Customer review, 5-star rating" data-id="element-135">
                <div className="flex items-center gap-0.5 text-amber-500 mb-1.5" aria-hidden="true" data-id="element-136">
                  {[0, 1, 2, 3, 4].map(i => <svg key={i} className="w-3 h-3 fill-current" viewBox="0 0 20 20" data-id="element-137">
                      <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-138" />
                    </svg>)}
                </div>
                <p className="text-xs text-neutral-600 italic leading-relaxed" data-id="element-139">
                  "[Paste real customer review here.]"
                </p>
                <p className="text-[10px] text-neutral-500 mt-1 not-italic" data-id="element-140">
                  [Customer Name], [City]
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}